import { getUserSettings } from "api/user/user-settings";

export const queryUserSettings = ({ user }) => ({
	queryKey: ["user-settings", user?.uid],
	queryFn: async () => getUserSettings({ authToken: user?.accessToken }),
});
